import React from 'react';
import Asterisk from '../../shared/components/Asterisk';
import cx from 'classnames';

/**
 * @typedef {object} TextInputFieldProps
 * @property {string} [title]
 * @property {string} [name]
 * @property {string} [id]
 * @property {string} [placeholder]
 * @property {string} [value]
 * @property {(event: React.ChangeEvent<HTMLInputElement>) => void} [handleChange]
 * @property {number} [maxLength]
 * @property {boolean} [disabled]
 */

/**
 * @param {TextInputFieldProps} props
 */
const TextInputField = props => {
  const {
    handleChange,
    maxLength,
    title = '',
    name = '',
    id = '',
    placeholder = '',
    value = '',
    disabled = false
  } = props;

  return (
    <>
      <h4 className='field-title' data-testid={`field-title-${id}`}>
        {title}
        <Asterisk />
      </h4>
      <input
        className={cx('input-field', { disabled: disabled })}
        id={id}
        type='text'
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        maxLength={maxLength}
        disabled={disabled}
        required
      />
    </>
  );
};

export default TextInputField;
